import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzIconButtonMenu} from "core/components/buttons/icons";
import jobService from "core/job/jobService";
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import {formatId} from "core/common/utils/utils";
import Add from "material-ui/svg-icons/content/add";
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {ObservableMap} from "mobx";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {GridLocation} from "core/grid/domain/grid";
import {loc} from "core/common/config/locales";

const gridLocation = 'jobList';

@observer
export default class JobList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = loc.i18n`Jobs`;
  static icon = 'cogs';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("JobList#fetchData(%s)", gridLocation);
    return Promise.all([gridService.fetchGrids(gridLocation), jobService.readAvailableJobs()])
      .then(([gridLocationMap, availableJobs]: [ObservableMap<GridLocation>, {[key: string]: string[]}]) => {
        jobService.availableJobs = availableJobs;
        return gridService.getOrCreateGrid(gridLocation);
    })
  }

  addJob = (groupName: string, jobName: string) => {
    console.log('addJob ' + jobName);
    this.context.router.transitionTo("jobDetail", {id: formatId(groupName, jobName)}, {new:true});
  };




  render() {
    let {params, query} = this.props;

    console.debug("jobList render");

    let menuItems = [];
    if (jobService.availableJobs) {
      Object.entries(jobService.availableJobs).forEach( (pair, index) => {
        let groupName = pair[0];
        let jobsInGroup = pair[1];
        if (index > 0) menuItems.push(<Divider key={groupName} />);
        jobsInGroup.forEach(job => {
          menuItems.push(<MenuItem primaryText={groupName + ' - ' + job} key={groupName + job} onClick={this.addJob.bind(this, groupName, job)}/>);
        })
      })
    }

    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}>
          <ZzIconButtonMenu buttonIcon={<Add/>}>
            {menuItems}
          </ZzIconButtonMenu>
        </GridCompConnected>

    );
  }

}



// WEBPACK FOOTER //
// ./src/core/job/jobList.tsx